// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-episode-card {
  align-self: stretch;
  display: inline-block;
  width: calc(100% - 20px);
  border: 2px solid var(--hero-title-color);
  max-width: 600px;
  margin-left: 10px !important;
  margin-right: 10px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.hero-episode-card:hover {
  background-color: var(--hero-episode-card-bg-hover);
}
@media (min-width: 1200px) {
  .hero-episode-card {
    max-width: 510px;
  }
}
@media (min-width: 1600px) {
  .hero-episode-card {
    max-width: 610px;
  }
}
.hero-episode-card__container {
  padding: 20px;
}
.hero-episode-card__title {
  font-weight: 600;
  margin-bottom: 7px;
  color: var(--hero-title-color);
  font-size: var(--hero-date-font-size-mobile);
}
@media (min-width: 1200px) {
  .hero-episode-card__title {
    font-size: var(--hero-date-font-size-desktop);
  }
}
.hero-episode-card__live-date {
  color: var(--hero-date-color);
  font-size: var(--hero-date-font-size-mobile);
  font-weight: var(--hero-date-font-weight) !important;
}
@media (min-width: 1200px) {
  .hero-episode-card__live-date {
    font-size: var(--hero-date-font-size-desktop);
  }
}
.hero-episode-card__vod-date {
  color: var(--hero-date-color);
  font-size: var(--hero-vod-date-font-size-mobile);
  font-weight: var(--hero-vod-date-font-weight) !important;
}
@media (min-width: 1200px) {
  .hero-episode-card__vod-date {
    font-size: var(--hero-vod-date-font-size-desktop);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Hero/HeroEpisodeCard/HeroEpisodeCard.scss"],"names":[],"mappings":"AAEA;EACI,mBAAA;EACA,qBAAA;EACA,wBAAA;EACA,yCAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;EACA,eAAA;EACA,sCAAA;AADJ;AAGI;EACI,mDAAA;AADR;AAII;EAjBJ;IAkBQ,gBAAA;EADN;AACF;AAGI;EArBJ;IAsBQ,gBAAA;EAAN;AACF;AAEI;EACI,aAAA;AAAR;AAGI;EACI,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,4CAAA;AADR;AAGQ;EANJ;IAOQ,6CAAA;EAAV;AACF;AAGI;EACI,6BAAA;EACA,4CAAA;EACA,oDAAA;AADR;AAGQ;EALJ;IAMQ,6CAAA;EAAV;AACF;AAGI;EACI,6BAAA;EACA,gDAAA;EACA,wDAAA;AADR;AAGQ;EALJ;IAMQ,iDAAA;EAAV;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
